<div class="bg-primary d-lg-none d-block" #barcode>
  <fgb-barcode [showBarcode]="true" [showWallet]="false"></fgb-barcode>
</div>

<div #walletContainer class="mobile-content-wrapper">
  <div class="grab-point d-lg-none"><span class="minimize-icon"> </span></div>
  <!-- V2 Wallet -->
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel pt-4">
      <div class="container">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <div class="container mt-4">
    <div class="border p-3 rounded-4 bg-white margin-30">
      <div class="row">
        <div class="col-lg-9">
          <div class="claimed-box font-size-18">{{ 'rewards.wallet.history' | translate }}</div>
          <div class="font-size-14">{{ 'rewards.wallet.history.description' | translate }}</div>
        </div>
        <div class="col-lg-3 mt-4 mt-lg-2">
          <a
            class="btn w-100 text-black bg-white border-add-card d-flex flex-row align-items-center justify-content-center fw-bold"
            [routerLink]="['/rewards/claimed']"
          >
            {{ 'rewards.wallet.view.claimed' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
